import { UpdateBloodPressureInput } from 'types/graph';

import { BloodPressureFormValues } from '../form/types';

const buildInput = (values: BloodPressureFormValues): UpdateBloodPressureInput => {
  const input: UpdateBloodPressureInput = {
    systolicPressure: values.systolicPressure || null,
    diastolicPressure: values.diastolicPressure || null,
    lastTreatedAt: values.lastTreatedAt,
    controlledWithMedication: values.controlledWithMedication,
  };

  if (values.controlledWithMedication) {
    input.controlledWithMedicationSince = values.controlledWithMedicationSince;
  }

  return input;
};

export default buildInput;
